import { render, staticRenderFns } from "./FamilyFeedbackRequests.vue?vue&type=template&id=a051756e&scoped=true"
import script from "./FamilyFeedbackRequests.ts?vue&type=script&lang=ts&external"
export * from "./FamilyFeedbackRequests.ts?vue&type=script&lang=ts&external"
import style0 from "./FamilyFeedbackRequests.vue?vue&type=style&index=0&id=a051756e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a051756e",
  null
  
)

export default component.exports